import script from "./bonusPrograms.vue?vue&type=script&setup=true&lang=js"
export * from "./bonusPrograms.vue?vue&type=script&setup=true&lang=js"

import "./bonusPrograms.vue?vue&type=style&index=0&id=10b4d6be&scoped=true&lang=less"
import "./bonusPrograms.vue?vue&type=style&index=1&id=10b4d6be&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b4d6be"]])

export default __exports__